import { TextField } from '@material-ui/core';
import { AutocompleteRenderInputParams } from '@material-ui/lab';

export default function CompleteInput(props: { params: AutocompleteRenderInputParams, label: string, required?: boolean, error?: string }) {
	const { params, label, required } = props;

	return (
		<TextField
			error={!!props.error}
			helperText={props.error}
			{...params}
			label={label}
			variant="outlined"
			fullWidth
			inputProps={{
				...params.inputProps,
				style:
					required && !params.InputProps.startAdornment
						? {
							borderLeft: "5px solid orange",
							marginLeft: "-9px",
							minHeight: "35px",
							marginTop: "-8px",
							marginBottom: "-8px",
							borderRadius: "5px 0px 0px 5px",
						}
						: undefined,
			}}
		/>
	);
}
